<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-table"></i>
        Agent
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WSFinder</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Agent</a>
          </li>
      </ul>
    </div>
    <vcl-facebook v-if="loading"></vcl-facebook>
    <b-card v-else>
    <!-- <router-view @refresh="refresh()"></router-view> -->
    <div>
      <span class="font-weight-bold">
        {{model.host || '-'}}
        ({{(model.ip_addr_public ? model.ip_addr_public : model.ip_addr) || '-'}})
      </span>
      <b-badge variant="success" v-if="model.alive == true">Online({{model.ms}} ms)</b-badge>
      <b-badge v-else>Offline</b-badge>
      <b-badge v-if="model.alive == true && model.status && model.status.running && model.status.is_real_time == false" variant="primary">
        Self Checking
      </b-badge>
      <b-badge v-else-if="model.alive == true && model.status && (model.setting.realtime_mode || model.status.scaning_real_time == true)" variant="warning">
        Real-time monitoring
      </b-badge>
      <span class="float-right">Installed Date : {{model.created_at | datetime}} </span>
    </div>
    <hr>
    <b-card v-if="!quick_setting_status">
      <b-row>
        <b-col md="4" class="text-center" style="height:180px;">
          <div
            @click="modal_modify = true"
            :style="`cursor:pointer;display: inline-block; background-color: ${model.status.last_detect_count ? 'orange' : 'skyblue'}; border:1px solid ${model.status.last_detect_count ? 'orange' : 'skyblue'}; width:150px; font-weight: 800; height:150px; border-radius:75px; text-align:center; margin:0 auto; font-size:15px; color:#fff; vertical-align:middle; line-height:150px`"
          >
            <small class="font-weight-bold">{{model.name}}</small>
          </div>
        </b-col>
        <b-col md="8" style="height:fit-content;">
          <table class="w-100">
            <thead>
              <th class="p-1">#</th>
              <th class="p-1">Time</th>
              <th class="p-1">Detail</th>
            </thead>
            <tbody>
              <tr>
                <td class="p-1">Recent Check results</td>
                <td class="p-1" v-if="model && model.status">{{model.status.last_scan_date | datetime}} </td>
                <td class="p-1" v-else>-</td>
                <td class="p-1">
                  Total : {{model.status.last_scan_count || 0 }} File Check
                </td>
                <td>
                  <b-btn block class="float-right" size="sm" variant="primary" @click="modal_modify = true"> Change nickname </b-btn>
                </td>
              </tr>
              <tr>
                <td class="p-1">Recent Detection Details</td>
                <td class="p-1" v-if="model && model.status">{{model.status.last_detect_date | sdate}} </td>
                <td class="p-1" v-else>-</td>
                <td class="p-1">
                  Total : {{model.status.last_detect_count || 0 }} File Check
                </td>
                <td>
                  <b-btn block class="float-right btn-add" size="sm" variant="success" @click="modal_upgrade = true"> Upgrade agent</b-btn>
                </td>
              </tr>
              <tr>
                <td class="p-1">Touch Time</td>
                <td class="p-1" v-if="model && model.touched_at">{{model.touched_at | sdate}} </td>
                <td class="p-1" v-else>-</td>
                <td class="p-1">
                  -
                </td>
                <td>
                  <b-btn block class="float-right" size="sm" variant="danger" @click="del_confirm = true"> Delete</b-btn>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <!-- 메모리 차트 영역 -->
        <b-col class="fadeIn fadeOut" :md="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0 ? 4 : 6">
          <div v-if="model.chart.memory.series && model.chart.memory.series.length > 0">
            <VueApexCharts type="area" height="150" ref="_chart_memory" :options="model.chart.memory" :series="model.chart.memory.series" />
          </div>
        </b-col>
        <!-- cpu 차트 영역 -->
        <b-col class="fadeIn fadeOut" :md="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0 ? 4 : 6">
          <div v-if="model.chart.memory.series && model.chart.memory.series.length > 0">
            <VueApexCharts type="area" height="150" ref="_chart_cpu" :options="model.chart.cpu" :series="model.chart.cpu.series" />
          </div>
        </b-col>
        <!-- cpu work load -->
        <b-col class="fadeIn fadeOut" md="4">
          <div v-if="model.status.system_cpu_info && model.status.system_cpu_info.usages && model.status.system_cpu_info.usages.length > 0">
            <VueApexCharts type="heatmap" height="140" ref="_chart_workload" :options="model.chart.workload" :series="model.chart.workload.series" />
          </div>
        </b-col>
      </b-row>
      <hr>
      <b-row class="text-center">
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              HOST
            </div>
            {{model.host}}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              IP
            </div>
            <span v-if="!model.ip_addr_public || !model.ip_addr_private">{{model.ip_addr}}</span>
            <span v-else>
              <span v-if="model.ip_addr_public">
                <span v-if="model.ip_addr_public == model.ip_addr_private">
                  {{ model.ip_addr_public }}
                </span>
                <span v-else>
                  {{ model.ip_addr_public }} /  {{ model.ip_addr_private }}
                </span>
              </span>
              <span v-else>
                {{ model.ip_addr_private }}
              </span>
            </span>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              OS
            </div>
            {{model.os_type}}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold" v-b-tooltip.hover.right title="You'll get notifications when updates are available">
              <span>
                Version
                <Bell style="display: inline-block;" :size="20" :count="1" v-if="!is_latest()"/>
              </span>
            </div>
            {{model.version}}
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <div slot="label" class="font-weight-bold">
              WFDetector
            </div>
            <strong>
              <b-badge class="" :variant="model.setting.forgery_mode ? 'success' : 'default'" >{{ model.setting.forgery_mode ? 'Enable' : 'disable' }}</b-badge>
            </strong>
          </b-form-group>
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6" v-if="model.setting.scan_list && model.setting.scan_list.length > 0">
          <center class="m-1">Monitoring Folder Preview</center>
          <white-Path :preview="true" :white_path="model.setting.scan_list || []" :show="true" @save="index = 0"></white-Path>
        </b-col>
        <b-col md="6" v-else>
          <center class="m-1">No have Monitoring Folder</center>
        </b-col>
        <b-col md="6" v-if="model.setting.white_path && model.setting.white_path.length > 0">
          <center class="m-1">exception folder preview</center>
          <white-Path :preview="true" :white_path="[].concat(model.setting.white_path || []).concat(model.setting.white_file || [])" :show="true" @save="index = 0"></white-Path>
        </b-col>
        <b-col md="6" v-else>
          <center class="m-1">No have Exception Folder</center>
        </b-col>
      </b-row>
    </b-card>
    <hr>
    <template v-if="quick_setting_status" class="animated fadeIn fadeOut">
      <SettingQuickSetup
        v-if="quick_setting_status"
        :is_one="is_one"
        :is_first="is_first"
        :dir="dir"
        :scan_list="scan_list"
        :now_setting="model.setting"
        :os_type="model.os_type"

        @status="() => { quick_setting_status = false; is_first = false }"
        @remove="remove_select"
        @clear="clear"
        @get_path="(x) => { this.get_path(x) }"
        @save_quick="(setting) => { this.model = Object.assign({}, this.model, { setting : setting }); this.save_setting() }"
      >
      </SettingQuickSetup>
    </template>
      <b-tabs v-else active-nav-item-class="font-weight-bold text-uppercase text-danger" v-model="index">
        <b-tab @click="folder()" title="Folder">
          <folderSet
          :os_type="model.os_type"
            :is_refresh="model.alive"
            :show="dir.length"
            :item="dir"
            :scan_list="scan_list"
            :scan_list_history="model.setting.scan_list_history"
            :white_path="white_path"
            :white_file="white_file"
            :disk_list="disckStatus"

            @path="get_path"
            @save="folder_save"
            @remove="remove_select"
            @clear="clear"

            @add_white_list_file="add_white_list_file"
            @add_white_list="add_white_list"
            @add_scan_list="add_scan_list"

          />
        </b-tab>
        <b-tab title="Setting">
          <b-row class="text-center">
            <b-col md="2">
            </b-col>
            <b-col md="4">
              <b-button block size="sm" variant="success" @click="save_setting" :disabled="runStatus" class="pr-2 pl-2 btn-add" style="min-width: 5.0rem;">
                {{ runStatus ? "Scanning, try later" : 'Save' }}
              </b-button>
            </b-col>
            <b-col md="4">
              <b-form-group>
                <b-button block size="sm" variant="warning" @click="apply_modal = true">
                  Apply to other servers
                </b-button>
                <br>
                <small class="font-weight-bold text-danger">* All settings on the Settings tab apply to the selected agent</small>
              </b-form-group>
            </b-col>
            <b-col md="4">
            </b-col>
          </b-row>
              <hr>
              <b-row class="text-center">
                <b-col>
                  <b-form-group :label-cols="4">
                    <div slot="label" class="font-weight-bold">
                      <span v-b-tooltip.hover.right title="Set the policy to be used for inspection">
                        * Scan Policy
                        <span class="text-info">

                          <i style="cursor:pointer" class="fas fa-question-circle"></i>
                        </span>
                      </span>

                    </div>
                <b-form-checkbox-group id="ph_status" v-model="model.setting.rule">
                  <b-form-checkbox value="Regex">Regex</b-form-checkbox>
                  <b-form-checkbox value="Hash">Hash</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">Ssdeep</b-form-checkbox>
                  <b-form-checkbox value="OB">Obfuscation</b-form-checkbox>
                  <b-form-checkbox v-if="is_show_beta()" value="ML">Machine Learning</b-form-checkbox>
                </b-form-checkbox-group>
                <b-form-input v-if="model.setting.rule.indexOf('ML') > -1" placeholder="Please enter AI URL" type="text" v-model="model.setting.url"></b-form-input>
              </b-form-group>
              <br>
              <b-form-group :label-cols="4">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Set whether to monitor in real time">
                    Real-time monitoring
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group v-model="model.setting.realtime_mode">
                  <b-form-radio :value="true">Enable</b-form-radio>
                  <b-form-radio :value="false">Disable</b-form-radio>
                </b-form-radio-group>
              </b-form-group>

            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="4" label="">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Set the inspection schedule A maximum of 10 configurations is recommended at dawn or at a time when there is no load on the server resources">
                    * Scan Schedule
                    <span class="text-info">

                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                    <br>
                    <small>Up to 10 schedules available</small>
                  </span>
                </div>
                <Schedule :now_schedule="model.setting.schedule" @save="x => model.setting.schedule = x" :hide_text="true" />
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col>
              <b-form-group :label-cols="2">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Sets whether detected Web shell files are backed up The file is not accessible from the web after the backup This is a recommended setting, but files in typos may be backed up">
                    Isolation mode
                    <span class="text-info">

                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-form-radio-group style="display:inline-block" v-model="model.setting.backup_mode">
                  <b-form-radio :value="false">Manual</b-form-radio>
                  <b-form-radio :value="true">Automatic</b-form-radio>
                </b-form-radio-group>
                [
                <b-form-checkbox-group style="display:inline-block" v-model="model.setting.backup_type_list" :disabled="!model.setting.backup_mode">
                  <b-form-checkbox value="Regex">Regex</b-form-checkbox>
                  <b-form-checkbox value="Hash">Hash</b-form-checkbox>
                  <b-form-checkbox value="Url">Url</b-form-checkbox>
                  <b-form-checkbox value="Ssdeep">SSDEEP</b-form-checkbox>
                  <!-- <b-form-checkbox value="OB">난독화</b-form-checkbox> -->
                  <!-- <b-form-checkbox value="ML">Machine Learning</b-form-checkbox> -->
                </b-form-checkbox-group>
                ] <br> <small class="text-danger">* Obfuscation do not allow automatic isolation</small>
              </b-form-group>
            </b-col>
            <b-col class="border-left">
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Set the isolation path If the path does not exist, it automatically creates a folder on that path Defaults to 'C:\wfinder_backup' for Windows and '/opt/f1/wsfinder_backup' for Linux are set to default at installation">
                    Isolation Path
                    <span class="text-info">

                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                  <b-form-input placeholder="require the folder path" id="input-small3" type="text" v-model="model.setting.backup_path"></b-form-input>
                  <b-button size="sm" variant="link" @click="modal_scan_list_history = true">prevoius history</b-button>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <b-col>
              <hr>
              <b-button class="btn-addition" style="position: relative; top:-30px; width: 80%;" v-b-toggle.collapse-1-inner size="sm" variant="light">Add Options</b-button>
            </b-col>
          </b-row>

          <b-collapse id="collapse-1-inner" class="mt-2">
            <b-row>
              <b-col>
                <b-form-group :label-cols="3">
                  <div slot="label" class="font-weight-bold">
                    <span v-b-tooltip.hover.right title="You can filter by extension in the inspection target Use to monitor only specific files">
                      Setting extensions
                      <span class="text-info">

                        <i style="cursor:pointer" class="fas fa-question-circle"></i>
                      </span>
                    </span>
                  </div>
                  <b-input-group>
                    <b-form-input type="text" v-model="converter"></b-form-input>
                  </b-input-group>
                  <small class="help-block">Setting extensions, example) txt,php,aspx,js, ...</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Scan only files with sub-conditions size in the folder you monitor">
                    Maximum file size
                    <span class="text-info">

                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                </div>
                <b-input-group>
                    <b-form-input type="number" v-model="model.setting.max_filesize"></b-form-input>
                </b-input-group>
                <small class="help-block">Default : 10M</small>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3">
                <div slot="label" class="font-weight-bold">
                  <span v-b-tooltip.hover.right title="Sets whether an updated system pattern is automatically applied to check It is recommended that these settings be enabled If not used, you can update the updated pattern manually">
                    Automatically apply patterns
                    <span class="text-info">
                      <i style="cursor:pointer" class="fas fa-question-circle"></i>
                    </span>
                  </span>
                  <!-- 시스템 패턴 자동 적용 -->
                </div>
                <b-form-radio-group v-model="model.is_allow_system">
                  <b-form-radio :value="true">Enable</b-form-radio>
                  <b-form-radio :value="false">Disable</b-form-radio>
                  <b-button class="btn-add" size="sm" variant="success" @click="system_pattern_manual" :disabled="model.is_allow_system == true || model.available_system_pattern_count < 1 || this.model.is_testing">
                    <b-badge pill variant="warning" >{{ model.available_system_pattern_count | number }}</b-badge>
                    <span v-if="!model.is_testing">
                      Available new System Pattern
                    </span>
                    <span v-else>
                      Request testing, the result is will be noticed by email
                    </span>
                  </b-button>
                </b-form-radio-group>
                <small class="text-danger">Recommended Enable</small>
              </b-form-group>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="12">
              <p style="display:inline-block; cursor: pointer;" @click="model.setting.limit_mode = !model.setting.limit_mode">
                <span v-b-tooltip.hover.right title="Monitors the resources of the installed server You can receive mail notifications when the set limit is reached">
                  Resource Monitoring Alerts
                  <span class="text-info">

                    <i style="cursor:pointer" class="fas fa-question-circle"></i>
                  </span>
                </span>
                <!-- <span class="mr-3">자원 모니터링 알림</span> -->
                <i v-if="model.setting.limit_mode" class="fa fa-refresh fa-spin"></i>
              </p>
              <c-switch class="float-right" color="success" label variant="pill" v-model="model.setting.limit_mode"/>
              <br>
              <small class="text-danger">If the system resource is above the threshold, the first notification is generated, <br> and the notification is possible when the standard is normal. We recommend 90% thresholds and 60% normal standards. </small>
            </b-col>
          </b-row>
          <hr>
          <b-row class="text-center">
            <b-col sm="2" class="mt-2">CPU Threshold(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM Threshold(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk Threshold(90%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" placeholder="90" v-model="model.setting.limit_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row class="text-center">
            <!-- 여기서 라인 나눔 -->
            <b-col sm="2" class="mt-2">CPU Normal(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_cpu"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">RAM Normal(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_ram"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col sm="2" class="mt-2">Disk Normal(60%)</b-col>
            <b-col sm="2">
              <b-input-group append="%" class="mt-1 mb-1">
                  <b-form-input :number="true" type="number" v-model="model.setting.resolve_disk"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
        </b-collapse>
        </b-tab>
        <!-- 점검 탭 -->
        <b-tab title="Checking" v-if="(model.status && model.alive)">
          <b-row>
            <b-col md="3">
              <b-form-group v-if="model && model.status">
                Agent Status
              </b-form-group>
            </b-col>
            <b-col md="2">
              {{model.status.running && model.status.is_real_time == false ? (scan_status.stopping ? "On Stopping" : `On Going`) : 'On Standby'}}
              <span v-if="model.status.running && model.status.is_real_time == false">
                <i class="fa fa-refresh fa-spin"></i>
              </span>
            </b-col>
            <b-col md="2">
              <b-button block v-if="model.status && !scan_status.running" size="sm" variant="primary" @click="start_scan" :disabled="!model.ms">
                Start now
              </b-button>
              <b-button block v-else size="sm" variant="danger" @click="stop_scan" :disabled="scan_status.stopping || !model.status.percentFile">
                <b-spinner v-if="model.status && !model.status.percentFile" small type="grow"></b-spinner>
                {{ model.status && !model.status.percentFile ? 'Loading' : 'Suspend now'}}
              </b-button>
            </b-col>
            <b-col md="6"></b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group v-show="runStatus">
                Checking Start -
                <span v-if="model.status && !model.status.percentFile">loading</span>
                <span v-else> {{model.status.scan_date | datetime}}</span>
                <span class="text-danger float-right">* Scan and check files at the same time, which may cause inconsistent progress </span>
              </b-form-group>
            </b-col>
          </b-row>
          <hr v-if="runStatus">
          <b-progress v-show="runStatus" class="mt-2 animated fadeIn fadeOut" :max="model.status.percentFolder != 0 ? 200 : 100" show-value ref="progressbar">
            <b-progress-bar v-if="model.status.percentFolder != 0" :label="`${model.status.percentFolder || 0} %`" show-progress animated :precision="1" :value="model.status.percentFolder || 0" variant="info"></b-progress-bar>
            <b-progress-bar :label="`${model.status.percentFile || 0} %`" show-progress animated :precision="1" :value="model.status.percentFile || 0" variant="dark"></b-progress-bar>
          </b-progress>
          <hr>
          <b-row>
            <b-col>
              <b-form-group :label-cols="3" label="Current Progress status" v-if="runStatus">
              <span> <b-badge pill variant="dark" >File</b-badge> : {{model.status.scan_count}} of {{model.status.scan_count_left}}  Check completed - {{ model.status.percentFile || 0 }} % </span> <br>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`Current Luncher started time`" v-if="model && model.status">
                <label v-if="scan_status.running && !model.status.percentFile">Loading.....</label>
                <label v-else>{{model.status && model.status.start | datetime}}</label>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`Recent Check details`" v-if="model && model.status"><label>{{model.updated_at | datetime}} / Total : {{model.status.last_scan_count || 0}} Files</label></b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="12">
              <b-form-group :label-cols="3" :label="`Recent Detection details`" v-if="model && model.status"><label>{{model.updated_at | datetime}} / Total : {{model.status.last_detect_count || 0}} Detections </label></b-form-group>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab title="Checking" v-else>
          <b-row>
            <b-col md="5">
              Agent Offline
            </b-col>
          </b-row>
        </b-tab>
        <!-- 탐지 탭 -->
        <b-tab @click="$refs._dl && $refs._dl.refresh()">
          <template slot="title">
            Detect List
            <span class="badge badge-danger">{{`${detect_item || 0}`}}</span>
          </template>
          <b-table ref="_dl" striped hover small class="table_add" :items="getDetect" :fields="detect_fields" :current-page="so_detect.currentPage" :per-page="so_detect.perPage" v-show="detect_item">
            <template slot="created_at" slot-scope="row">{{ row.item.created_at | datetime }}</template>
            <template slot="path" slot-scope="row">{{row.item.path}}</template>
            <template slot="type" slot-scope="row">{{row.item.category || JSON.parse(detect_model.description).type}}</template>
            <template slot="select" slot-scope="row">
              <b-btn size="sm" @click="detect_select(row.item)" variant="dark">Check</b-btn>
              <b-btn size="sm" @click="backup(row.item)" variant="warning"> Isolation </b-btn>
              <b-btn class="btn-add" size="sm" @click="detect_exception(row.item)" variant="success"> Exception </b-btn>
              <b-btn size="sm" @click="detect_download(row.item)" variant="primary"> Download </b-btn>
              <!-- <b-btn size="sm" @click="backup_remove_raw(row.item)" variant="danger"> 삭제 </b-btn> -->
            </template>
          </b-table>
          <hr>
          <b-col class="md-4" v-if="detect_item">
            <b-pagination size="sm"  align="center":total-rows="detect_item" :per-page="so_detect.perPage" v-model="so_detect.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <template v-if="!detect_item">
            <strong>No history detected</strong>
          </template>
          <!-- 상세보기 모달 -->
          <b-modal size="lg" ref="detect_modalRef" title="Detect Result" ok-only>
            <div class="text-center h6 w-100">
              <table class="text-center h5 w-100">
                <thead>
                  <tr>
                    <th style="background-color:orange;border-radius: 12px;" colspan="2">Detect Info</th>
                  </tr>
                </thead>
                <tbody class="h6">
                  <tr>
                    <td class="p-2">Agent</td>
                    <td class="p-2">{{model.name}}[{{model.host}}@{{model.ip_addr}}]</td>
                  </tr>
                  <tr>
                    <td class="p-2">IP Address</td>
                    <td class="p-2">{{ model.ip_addr_public }} / {{ model.ip_addr_private }}</td>
                  </tr>
                  <tr>
                    <td class="p-2">Detect Time</td>
                    <td class="p-2">{{detect_model.created_at | datetime}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">Isolation</td>
                    <td class="p-2 text-danger">{{detect_model.is_backup ? `Yes` : `No`}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">Type</td>
                    <td class="p-2">{{detect_model && detect_model.description ? detect_model.description.type : '-'}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">Code</td>
                    <td class="p-2">{{detect_model && detect_model.description ? detect_model.description.code : '-'}}</td>
                  </tr>
                  <tr>
                    <td class="p-2">Line</td>
                    <td class="p-2" v-if="detect_model && detect_model.description">{{detect_model.description.numerical > 0 ? detect_model.description.numerical : '-'}}</td>
                    <td class="p-2" v-else>-</td>
                  </tr>
                </tbody>
              </table>
              <b-btn size="sm" @click="copyText('ph_content')" variant="primary" block> Path </b-btn>
              <pre class="mt-4" ref="ph_content" id="ph_content">{{detect_model.path}}</pre>
              <b-btn size="sm" @click="copyText('ph_data')" variant="primary" block> Detection data (display only part of that line) </b-btn>
              <pre class="mt-4" ref="ph_data" id="ph_data" v-if="detect_model && detect_model.description">{{detect_model.description.value ? detect_model.description.value : '-'}}</pre>
            </div>
          </b-modal>
        </b-tab>
        <!-- 결과 탭 -->
        <b-tab @click="$refs._rl && $refs._rl.refresh()">
          <template slot="title">
            Result List
            <span class="badge badge-primary">{{`${result_item || 0}`}}</span>
          </template>
          <b-table ref="_rl" striped hover small fixed class="table_add" :items="getResult" :fields="result_fields" :current-page="so_result.currentPage" :per-page="so_result.perPage" v-show="result_item">
            <template slot="scan_time" slot-scope="row">
              {{ row.item.scan_time | datetime }}
              ({{row.item.scanning_time}})
            </template>
            <template slot="scan_folder" slot-scope="row">{{row.item.scan_folder | number}}</template>
            <template slot="scan_count" slot-scope="row">{{row.item.scan_count | number}}</template>
            <template slot="detect_count" slot-scope="row">{{row.item.detect_count | number}}</template>
            <template slot="select" slot-scope="row">
              <b-button class="btn-secondary" size="sm" @click="result_select(row.item)">Check</b-button>
            </template>
          </b-table>
          <hr>
          <template v-if="!result_item">
            <strong>No details have been checked</strong>
          </template>
          <b-col class="md-4" v-if="result_item">
            <b-pagination size="sm"  align="center" :total-rows="result_item" :per-page="so_result.perPage" v-model="so_result.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-modal size="xl" ref="result_modalRef" title="" ok-only>
            <ResultDetail :id="result_model.id" />
          </b-modal>
        </b-tab>
        <!-- 격리 탭 -->
        <b-tab @click="save_box()" >
          <template slot="title">
            Isolation
            <span class="badge badge-warning">{{`${safe_box ? safe_box.length : 0}`}}</span>
          </template>
          <b-table ref="safe_list" striped hover small fixed class="table_add" :items="safe_box" :fields="safe_fields" :current-page="so_isolation.currentPage" :per-page="so_isolation.perPage" v-show="safe_box && safe_box.length">
            <template slot="path" slot-scope="row">{{row.item.path}}</template>
            <template slot="hash" slot-scope="row">{{row.item.hash && row.item.hash.indexOf('.') > -1 ? row.item.hash.split('.')[0] : row.item.hash}}</template>
            <template slot="created_at" slot-scope="row">{{ row.item.data | datetime }}</template>
            <template slot="select" slot-scope="row">
              <b-btn class="btn-add" size="sm" @click="backup_restore(row.item)" variant="success">Restore</b-btn>
              <b-btn class="btn-add" size="sm" @click="backup_exception(row.item)" variant="success">Exception</b-btn>
              <b-btn size="sm" @click="backup_remove_modal = true; remove_info = row.item; $refs.safe_list.refresh()" variant="danger">Remove</b-btn>
              <b-btn size="sm" @click="backup_download(row.item)" variant="primary">Download</b-btn>
            </template>
          </b-table>
          <template v-if="!safe_box || !safe_box.length">
            <tr>
              <th>No isolation path has been set or there are no quarantined files</th>
            </tr>
          </template>
          <b-col class="md-4" v-if="this.safe_box && this.safe_box.length">
            <b-pagination size="sm"  align="center":total-rows="this.safe_box && this.safe_box.length" :per-page="so_isolation.perPage" v-model="so_isolation.currentPage" prev-text="<" next-text=">" />
          </b-col>
          <b-modal size="lg" v-model="backup_remove_modal" @ok="backup_remove(remove_info)" ref="safe_modalRef" title="Remove">
            <p>
              Are you sure Remove it ?
            </p>
            <hr>
            <p>{{remove_info.path}} </p>
          </b-modal>
        </b-tab>
        <!-- <b-tab>
          <template slot="title">
            Exception
            <span class="badge badge-success">{{`${model.setting && model.setting.white_path ? model.setting.white_path.length : 0}`}}</span>
          </template>
          <white-Path :press="false" :show="true" :white_path="model.setting.white_path || []" @add="add_white_path" @save="save_setting" @remove="remove_path" @clear="model.setting.white_path = []"></white-Path>
        </b-tab> -->
        <b-tab>
          <template slot="title">
            WFDetector
            <b-img v-if="model && model.setting.forgery_mode" rounded src="img/checked.png" width="15" class="ml-1 mt-1 mb-1"></b-img>
          </template>
          <div>
            <b-jumbotron>
              <template v-if="model.setting.forgery_mode" slot="header">
                <b-img style="display: inline-block; width: 5%;" rounded :src="'img/checked.png'" class="mr-2"></b-img>
                <p style="display: inline-block;" class="h1">
                  WFDetector settings are enabled
                </p>
              </template>
              <template v-else slot="header">
                <p class="h1 font-weight-bold">
                  Enable forgery settings!
                </p>
              </template>

              <template slot="lead">
                <p>
                  Detects subfolders and files in the specified folder for forgery. Monitor settings and backup files for changes
                </p>
                <p>
                  Check the folder you set up! Changes can be made on the settings page
                </p>
                <b-row>
                <b-col>
                <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                  <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                    Counterfeit Monitoring Folder
                  </span>
                  <hr>
                </div>
                <small v-for="(item, index) in model.setting.snapshot.watching" v-bind:key="index+'_watching'">
                  {{item}}
                </small>
              </b-col>
              <b-col>
                <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                  <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                    Exceptions folder
                  </span>
                  <hr>
                </div>
                <small v-for="(item, index) in model.setting.snapshot.white_path" v-bind:key="index+'_white_path'">
                  {{item}}
                </small>
              </b-col>
              <b-col>
                <div class="text-center" v-if="model.setting.forgery_mode && model.setting.snapshot.watching.length">
                  <span style="position: relative; top: 1.8rem; background-color: #e4e7ea; font-weight: bold; padding: 0 15px;">
                    exception file
                  </span>
                  <hr>
                </div>
                <small v-for="(item, index) in model.setting.snapshot.white_file" v-bind:key="index+'_white_file'">
                  {{item}}
                </small>
              </b-col>
            </b-row>
              </template>
              <hr>
              <template>
                <b-button block variant="warning" to="/integrity/wsfinder">
                  <span v-if="model.setting.snapshot.watching && model.setting.snapshot.watching.length > 0">
                    Change settings :D
                  </span>
                  <span v-else>
                    Start Now :D
                  </span>
                </b-button>
              </template>
            </b-jumbotron>
          </div>
        </b-tab>
    </b-tabs>
    <b-modal size="xl" ref="scan_modalRef" title="" ok-only>
      <ResultDetail :result_data="result"/>
    </b-modal>
    <b-modal title="Delete"  class="modal-danger" v-model="del_confirm" @ok="remove" @cancel="del_nickname = '';" header-bg-variant="danger" ok-variant="danger">
      <p> When deleting an agent,</p>
      <p>the server must also perform the delete command.</p>
      <p>
        It will not be automatically deleted from the server.
      </p>
      <p>Delete according to the manual.</p>
      <p> <b> * Check Agent Name </b> </p>
      <p> Delete Agent Name : {{model.name}}  </p>
      <b-form-input v-model="del_nickname" placeholder="Typing The name of the server you want to unregister"></b-form-input>
    </b-modal>

    <b-modal hide-footer title="Agents to apply the policy to" size="xl" v-model="apply_modal" header-bg-variant='warning'>
      <b-badge variant="success" v-for="(item, index) in apply_all_server" :key="index+'_a'" class="m-1">
        <h6 @click="multi_remove(index)" style="cursor:pointer;">{{item.name}} <span class="m-1" style="cursor:pointer;">X</span></h6>
      </b-badge>
      <hr>
      <agent-List :agent_id="model.id" :list_selected="apply_all_server" :only_select="true" :view_detail="true" :server_agent="server_agent" @multi_clear="multi_clear" @multi_all="multi_all" @multi_one="multi_one"></agent-List>
      <hr>
      <b-button block variant="warning" @click="apply_confirm_modal = true" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_modal = false" class="m-1">Close</b-button>
    </b-modal>

    <b-modal hide-footer title="Confirm" size="xm" v-model="apply_confirm_modal" header-bg-variant='danger'>
      Are you sure apply setting to selected agent ?
      <hr>
      <b-button block variant="danger" @click="multi_save" class="m-1">Apply</b-button>
      <b-button block variant="info" @click="apply_confirm_modal = false" class="m-1">Close</b-button>
    </b-modal>
    <hr>
    <b-button v-if="quick_setting_status == false" class="float-left" variant="link" @click="quick_setting_status = true">Quick Guide Start</b-button>
    <b-button size="sm" class="float-right text-white" variant="secondary" @click="list"> List </b-button>

    <b-modal title="Modify"  class="modal-info" v-model="modal_modify" @ok="apply" header-bg-variant="info" ok-variant="info">
      <p> You can change the nickname of the server. </p>
      <p> Please enter a nickname to change. The first time, the server name is the hostname </p>
      <p> <b> * Check Server Name </b> </p>
      <p> Origin Server Nickname : {{model.name}}  </p>

      <b-form-input v-model="modify_nickname" placeholder="Typing for modify name"></b-form-input>
    </b-modal>

    <b-modal title="Upgrade"  class="modal-success" v-model="modal_upgrade" @ok="upgrade" header-bg-variant="success" ok-variant="success">
      <p>Are you sure want to upgrade agent ?</p>
      <p> Now Version({{model.version}}), up to more high</p>
    </b-modal>
    <b-modal title="Isolation Path history"  class="modal-info" v-model="modal_scan_list_history" @ok="modal_scan_list_history = false" ok-only header-bg-variant="info" ok-variant="info">
      <p v-if="!model.setting.backup_path_history || !model.setting.backup_path_history.length">no have previous data</p>
      <table v-else>
        <thead class="text-center font-weight-bold border-bottom">
          <tr>
            <td>
              DateTime
            </td>
            <td>
              Folder List
            </td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in model.setting.backup_path_history" v-bind:key="index+'_b'">
            <td class="text-center" style="width: 40%">
              {{x.updated_at | sdate}}
            </td>
            <td>
              <p class="m-1">{{ x.target }}</p>
              <!-- <p class="m-1" v-for="(y, index) in x.target_sub">{{y}}</p> -->
              <!-- TODO : 향후 이전 기록 바로 적용 추가 될 수 있음 -->
            </td>
          </tr>
        </tbody>
      </table>
    </b-modal>
  </b-card>
</div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>
